import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemEntity } from './item.entity';

@Index('fk_item__id', ['fkItemId'], {})
@Index('UK_item_sales_item_date_deleted', ['fkItemId', 'date'], {
	unique: true,
})
@Entity('item_sales')
export class ItemSalesEntity extends BaseEntity {
	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('int', { name: 'soldUnits', nullable: true })
	public soldUnits!: number | null;

	@Column('decimal', {
		name: 'revenue',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public revenue!: string | null;

	@Column('int', { name: 'uniqueClients', nullable: true })
	public uniqueClients!: number | null;

	@Column('int', { name: 'uniqueInvoices', nullable: true })
	public uniqueInvoices!: number | null;

	@Column('date', { name: 'date', nullable: true })
	public date!: string | null;

	@Column('int', { name: 'month', nullable: true })
	public month!: number | null;

	@Column('int', { name: 'year', nullable: true })
	public year!: number | null;

	@Column('decimal', {
		name: 'totalGPAggregate',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public totalGpAggregate!: string | null;

	@Column('decimal', {
		name: 'totalGPMargin',
		nullable: true,
		precision: 13,
		scale: 2,
	})
	public totalGpMargin!: string | null;

	@ManyToOne(() => ItemEntity, (item) => item.itemSales, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;
}
